import { render, staticRenderFns } from "./LocationsBookConfirm.vue?vue&type=template&id=46481492&scoped=true&"
import script from "./LocationsBookConfirm.vue?vue&type=script&lang=js&"
export * from "./LocationsBookConfirm.vue?vue&type=script&lang=js&"
import style0 from "./LocationsBookConfirm.vue?vue&type=style&index=0&id=46481492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46481492",
  null
  
)

export default component.exports